import React from 'react';
import PropTypes from 'prop-types';

import { createFormFieldsByIdGetter } from 'client/helpers/formikHelpers';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrCard from 'client/components/SrCard/SrCard';

const SrMarketingItems = ({ formikBag, formFields }) => {
  const getFormFieldsById = createFormFieldsByIdGetter(formFields);

  const photoFieldsDOM = (
    <>
      <SrFormikField
        formField={getFormFieldsById('availableForPhotoDate')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      <SrFormikField
        formField={getFormFieldsById('photosSpecialInstructions')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      <SrFormikField
        formField={getFormFieldsById('availableForPhotoDateSchedule')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      <SrFormikField
        formField={getFormFieldsById('availableForPhotoContactName')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      <SrFormikField
        formField={getFormFieldsById('availableForPhotoContactPhone')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
    </>
  );

  return (
    <SrCard>
      <SrFormikField
        formField={getFormFieldsById('yardSignAllowed')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
        margin="0"
      />
      <SrFormikField
        formField={getFormFieldsById('requireSelfShowingHardware')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      <SrFormikField
        formField={getFormFieldsById('requirePhotos')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      {formikBag.values.requirePhotos && photoFieldsDOM}
    </SrCard>
  );
};

SrMarketingItems.propTypes = {
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
};

SrMarketingItems.displayName = 'SrMarketingItems';

export default SrMarketingItems;
